const mutations = {
  setConstants(state, constants) {
    state.constants = constants;
  }
};

export default mutations;
